import { createFileRoute, Link } from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";
import { SellerPayoutsCard } from "@/components/SellerPayoutsCard";
import { SafeTradingCard } from "@/components/SafeTradingCard";
import { ShieldCheck, MessageCircle } from "lucide-react";

export const Route = createFileRoute("/_authenticated/payments")({
  head: () => ({ meta: [{ title: "Payments — Want To Buy" }] }),
  component: PaymentsPage,
});

function PaymentsPage() {
  return (
    <AppShell>
      <div className="mb-6">
        <h1 className="font-display text-3xl font-bold flex items-center gap-2">
          <ShieldCheck className="h-7 w-7 text-primary" /> Payments
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Want To Buy is a peer-to-peer directory. Buyers and sellers arrange
          payment directly — the platform never holds or processes funds.
        </p>
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <section className="panel p-5">
          <h2 className="font-display text-lg font-bold">As a buyer</h2>
          <p className="mt-1 text-sm text-muted-foreground">
            Message the seller from the order page to confirm the item and
            shipping. Pay them directly using{" "}
            <span className="font-semibold text-foreground">PayPal Goods &amp; Services</span> so
            you keep PayPal Buyer Protection.
          </p>
          <Link
            to="/messages"
            className="btn-primary mt-4 inline-flex items-center gap-2 px-4 py-2 text-sm"
          >
            <MessageCircle className="h-4 w-4" /> Open your messages
          </Link>
        </section>

        <section className="panel p-5">
          <h2 className="font-display text-lg font-bold">As a seller</h2>
          <SellerPayoutsCard />
        </section>
      </div>

      <div className="mt-6">
        <SafeTradingCard />
      </div>
    </AppShell>
  );
}
